import React from 'react'; 
import './animated-loading.css'

export const AnimatedLoading: React.FC = () => {
  return (
    <div className="rect">
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  )
}